<template>
    <v-container fluid class="d-flex align-center justify-center" style="padding: 0px;">
        <!-- 父頁面按鈕 -->
        <v-dialog 
            v-model="mainDialog" 
            class="main-dialog" 
            overlay-color="rgba(0, 0, 0, 0.9)"
            style="box-shadow: none;"
            @click="closeDialog"
        >
            <v-card class="main-box">
                <v-btn icon @click="mainDialog = false" class="close-btn">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <div class="container-box">
                    <div class="pic-box">
                        <v-img src="../assets/guide/choiceMessage.png" height="192" width="288"></v-img>
                    </div>
                    <!-- 彈窗內容 -->
                    <div class="btn-box">
                        <button class="btn-medium" @click="openDialog('online')">線上自行操作 </button><br>
                        <button class="btn-medium" @click="openDialog('help')">管理室協助</button>
                    </div> 
                </div>
            </v-card>
        </v-dialog>
  
      <!-- 父彈窗 -->
      <v-dialog v-model="dialog" class="carousel-container">
        <v-card class="carousel-box">
          <v-btn icon @click="dialog = false" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-card-text
            :style="{ height: 'auto' }"
            >
            <v-carousel 
                class= "carousel"
                v-model="currentPage" 
                :hide-delimiters="true"
                :continuous="false"
                show-arrows
                ref="carousel"
                :style="{ height: 'auto' }"
            >
              <v-carousel-item 
                  v-for="(page, index) in currentPages" 
                  :key="index"
                  :style="{ height: 'auto' }"
                >
                <v-container>
                  <div class="img-box">
                    <img 
                        :src="pagesAndImages[dialogType].images[page]" 
                        :alt="'Page image: ' + page"
                        :width="320"
                    >
                  </div>
                  <button class="btn-go"
                    v-show="['Page 1.5', 'Page 2.6'].includes(page)" 
                    @click="handleButtonClick()"
                  >
                    立即行動
                  </button>
                </v-container>
              </v-carousel-item>
              <template #prev>
                    <v-btn 
                      icon
                      @click="currentPage--"
                      :disabled="isPrevDisabled()" 
                    >
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                </template>

                <template #next>
                    <v-btn 
                      icon
                      @click="currentPage++"
                      :disabled="isNextDisabled()"
                    >
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </template>
            </v-carousel>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- 子彈窗 -->
      <v-dialog v-model="subDialog" max-width="500px">
        <v-card>
          <v-btn icon @click="subDialog = false" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  
  <script>
  import DIYStep1 from '../assets/guide/DIYStep1.jpg'
  import DIYStep2 from '../assets/guide/DIYStep2.jpg'
  import DIYStep3 from '../assets/guide/DIYStep3.jpg'
  import DIYStep4 from '../assets/guide/DIYStep4.jpg'
  import DIYStep5 from '../assets/guide/DIYStep5.jpg'
  import boothStep1 from'../assets/guide/boothStep1.jpg'
  import boothStep2 from'../assets/guide/boothStep2.jpg'
  import boothStep3 from'../assets/guide/boothStep3.jpg'
  import boothStep4 from'../assets/guide/boothStep4.jpg'
  import boothStep5 from'../assets/guide/boothStep5.jpg'
  import boothStep6 from'../assets/guide/boothStep6.jpg'

  export default {
    data() {
      return {
        showButton: false, 
        mainDialog: false,
        dialog: false, 
        subDialog: false, 
        dialogType: 'online', 
        page: 1,
        currentPage: ['Page 1.1'],
        currentPages: ['Page 1.1'],
        disablePrevPages: ['Page 1.1', 'Page 2.1'], // 禁用向左滑動的頁面
        disableNextPages: ['Page 1.5', 'Page 2.6'], // 禁用向右滑動的頁面
        pagesAndImages: { 
            online: {
                pages: ['Page 1.1', 'Page 1.2', 'Page 1.3', 'Page 1.4', 'Page 1.5'], 
                images: {
                'Page 1.1':  DIYStep1,
                'Page 1.2':  DIYStep2,
                'Page 1.3':  DIYStep3,
                'Page 1.4':  DIYStep4,
                'Page 1.5':  DIYStep5,
                },
            },
            help: {
                pages: ['Page 2.1', 'Page 2.2', 'Page 2.3', 'Page 2.4', 'Page 2.5', 'Page 2.6'], 
                images: {
                'Page 2.1': boothStep1,
                'Page 2.2': boothStep2,
                'Page 2.3': boothStep3,
                'Page 2.4': boothStep4,
                'Page 2.5': boothStep5,
                'Page 2.6': boothStep6,
                },
            },
        },
      };
    },
    methods: {
        closeDialog() {
          this.dialog = false;
        },
        openDialog(pageType) {
            // 設定當前選擇的頁面類型
            this.dialogType = pageType;

            // 設定對應的頁面內容（如果無對應頁面，設為空陣列）
            this.currentPages = this.pagesAndImages[pageType]?.pages || [];

            // 根據 `currentPages` 設定 `currentPage`
            this.currentPage = this.currentPages.length > 0 ? this.currentPages[0] : '';
            this.dialog = true;
        },
        handleButtonClick() {
            this.mainDialog = false;
            this.dialog = false;
            this.dialogType = ''; // 清空對話框類型
            this.currentPages = []; // 清空頁面內容 回到預設
        },
        // 禁用左側按鈕條件
        isPrevDisabled() {
            const disablePrevPages = ['Page 1.1', 'Page 2.1'];
            return disablePrevPages.includes(this.currentPages[this.currentPage]) || this.currentPage <= 0;
        },
        // 禁用右側按鈕條件
        isNextDisabled() {
            const disableNextPages = ['Page 1.5', 'Page 2.6'];
            return disableNextPages.includes(this.currentPages[this.currentPage]) || this.currentPage >= this.currentPages.length - 1;
        }
    },
}
  </script>
  

  <style scoped>
  /* 全頁面居中顯示 */
  .v-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width:320px;
  }

  .v-row {
    text-align: center;
    height: 400px;
    width:320px;
  }
  

  ::v-deep .v-window__prev,
  ::v-deep .v-window__next {
   display: none !important;
  }

  ::v-deep .v-window__prev,
  ::v-deep .v-window__next {
    display: block !important;
    position: fixed;
    z-index: 10;
    top: calc(90% - 40px);
    margin:0px, 30px;
  }

  ::v-deep .v-window__prev {
    left: 10px;
  } 

 ::v-deep .v-window__next {
    right: 20px;
  }

  ::v-deep .v-dialog.v-dialog--active {
  box-shadow: none;
  }

  ::v-deep.v-card__text {
    padding: 0 !important; 
  }

  .close-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    margin-bottom:20px;
    z-index:1;
  }

  .main-dialog {
    margin-bottom:68px;
    width:320px;
    height:472px;
  }

  .main-box {
    width:320px;
    height:472px;
    margin: auto;
  }

  .container-box {
    position:relative;
    top:68px;
  }
  
  ::v-deep .carousel {
    overflow: visible;  
  }

  ::v-deep .carousel-box{
    margin-top:44px;
    width:320px;
    height:554px;
    position: fixed; /* 固定在視窗的中間 */
    z-index:900;
    top: 50%; 
    left: 50%; 
    transform: translate(-50%, -55%); 
    overflow: visible !important;  /* 讓超出邊界的內容顯示 */
  }

  ::v-deep .carousel-item {
    position: relative;
    z-index: 1;  /* 確保 carousel-item 在按鈕下面 */
  }
  .pic-box {
    margin-left:10px;
  }

  ::v-deep .v-window-item
  ::v-deep .v-image
  ::v-deep .v-responsive
  ::v-deep .v-carousel__item
  ::v-deep .v-responsive__content{
    height: auto !important; /* 移除高度限制 */
    min-height: 0 !important; /* 移除最低高度 */
  }

  ::v-deep .v-image .v-responsive {
    margin-left: 10px;
  }

  ::v-deep .img-box {
    margin-top:30px;
    height: 100%;  
    position:relative !important;
  }

  ::v-deep .container {
   padding: 0 !important;
   margin-right:10px;
   width:320px !important;
  }

  ::v-deep .v-dialog.v-dialog--active {
    width: 320px !important;  
}

  ::v-deep .v-window__container 
  .v-window-item .v-image 
  .v-responsive  {
    width:320px !important;
    height:510px;
    max-width: none !important;
  }
  .btn-medium {
    padding: 10px;
    border-radius: 50px;
    height: 50px;
    width: 120px;
    line-height: 19.2px;
    letter-spacing: 2.2px;
    font-size: 14px;
    border: none;
    background-color: #0032A0;
    color: #FFFFFF;
    margin-top:28px;
    font-family:Noto Sans TC;
  }

  ::v-deep .btn-go {
    font-family:Noto Sans TC;
    position:absolute!important;
    z-index:9999 !important; 
    padding: 10px;
    border-radius: 50px;
    height: 50px;
    width: 120px;
    line-height: 19.2px;
    letter-spacing: 2.2px;
    font-size: 14px;
    border: none;
    background-color: #0032A0;
    color: #FFFFFF;
    bottom: -1px;
    left:105px;
  }

  .btn-go.show {
    visibility: visible;
    opacity: 1;
  }
  .btn-box {
    background-color:#5C6BC01A;
    border-top-left-radius: 50px;  
    border-top-right-radius: 50px; 
    margin:auto;
    width:320px;
    height:184px;
    position:relative;
    top:28px;
    text-align:center;
  }
  

  </style>
  
  